import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UserState {
    private userValue$ = new BehaviorSubject<any>(null);
    userDetails = this.userValue$.asObservable();

    public get getUserDetails() {
        return this.userValue$.value;
    }
    public set getUserDetails(status) {
        this.userValue$.next(status);
    }
}